const jump = {
  /**
   * 获得跳转目标ID列表
   * @param question
   * @returns {Array}
   */
  get (question) {
    let list = []
    if (question.jumpTargetId) {
      list.push(question.jumpTargetId)
    }
    if (question.options) {
      question.options.forEach((option) => {
        if (option.jumpTargetId) {
          list.push(option.jumpTargetId)
        }
      })
    }
    return list
  },

  /**
   * 判断题目是否存在跳转
   *
   * @param questions
   * @param question
   * @returns {boolean}
   */
  hasJump (questions, question) {
    if (question.jumpTargetId) {
      return true
    }
    if (question.options) {
      for (let option of question.options) {
        if (option.jumpTargetId) {
          return true
        }
      }
    }
    return false
  },

  /**
   * 置空题目中的逻辑跳转
   * @param question
   * @param questionId
   */
  empty (question, questionId) {
    if (question.jumpTargetId === questionId) {
      question.jumpTargetId = ''
    }

    if (question.options) {
      question.options.forEach((option) => {
        if (option.jumpTargetId === questionId) {
          option.jumpTargetId = ''
        }
      })
    }

    return question
  },

  /**
   * 移除题目中无效的逻辑跳转
   * 1、移除题目的 跳转目标INDEX 在 题目INDEX 之前的
   * 2、移除题目列表中 跳转来源INDEX 在 题目INDEX 之后的
   *
   * @param questions
   * @param index
   */
  removeInvalid (questions, index) {
    let jumps = this.get(questions[index])
    // 获得跳转目标题目的列表, 去除 end 特殊值
    let validJumps = jumps.filter((val) => val !== 'end')
    if (validJumps.length) {
      // 查找当前题目的跳转目标，跳转目标题目在当前题目的后面
      validJumps.forEach((questionId) => {
        // 获得跳转的目标题目
        let jumpIndex = questions.findIndex(({id}) => questionId === id)
        // 移除所有跳转，或者移除目标题目在当前题目之前的
        if (jumpIndex < index) {
          // 置空这个跳转ID
          this.empty(questions[index], questionId)
        }
      })
    }

    // 全部题目查找当前题目是否被当做跳转目标
    // 被当做跳转目标时，当前题目必须在其之后
    for (let i = index + 1; i < questions.length; i++) {
      let question = questions[i]
      if (this.get(questions[index]).includes(questions[index].id)) {
        // 置空这个跳转ID
        this.empty(question, questions[index].id)
      }
    }
  },
}

export default jump



// WEBPACK FOOTER //
// ./src/views/question-editor/utils/jump.js